module.exports = __webpack_public_path__ + "img/9c4bede.svg";